import React, { useEffect } from 'react';

import { Close } from '@mui/icons-material';
import { Button, Dialog, Grid, IconButton, Typography } from '@mui/material';
import {
  gray100,
  primary100,
  primaryButtonBackgroundColor,
  tertiaryButtonOutlinedColor
} from '../../constants/Colors';
import { getMemberProductList } from '../../api/db/product';
import { MyProductGetProductType } from '../../validation/products/productType';
import { useNavigate } from 'react-router-dom';

interface Props {
  setDialogOpen: (open: boolean) => void;
  onDelete: () => void;
  open: boolean;
  memberId: number;
}

const styles = {
  button: {
    boxSizing: 'border-box',
    height: '44px',
    width: 'calc(50% - 10px)'
  },
  dialog: {
    '& .MuiDialog-paper': {
      m: '16px',
      width: '560px',
      p: '24px'
    }
  },
  text: {
    color: gray100,
    fontSize: '16px',
    mt: '24px',
    whiteSpace: 'pre-line'
  },
  link: {
    color: primary100,
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: '700',
    textDecoration: 'underline'
  },
  title: {
    color: gray100,
    fontSize: '22px',
    fontWeight: '500'
  }
};

const DeleteMemberModal: React.FC<Props> = (props) => {
  const { setDialogOpen, onDelete, open, memberId } = props;
  const [show, setShow] = React.useState(false);
  const [amountOfProduct, setAmountOfProduct] = React.useState(0);
  const [products, setProducts] = React.useState<MyProductGetProductType[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    void (async () => {
      if (!memberId) return;
      const limit = 5;
      const offset = 0;
      const order = 1;
      const method = 1;
      const fetchData = await getMemberProductList(
        limit,
        offset,
        order,
        method,
        memberId
      );
      setProducts(fetchData.products);
      setAmountOfProduct(fetchData.total_count);
      setShow(true);
    })();
  }, [memberId]);

  return (
    <Dialog open={show && open} sx={styles.dialog}>
      <Grid container alignItems="center" justifyContent="space-between">
        <Typography sx={styles.title}>共有者を削除</Typography>
        <IconButton onClick={() => setDialogOpen(false)}>
          <Close />
        </IconButton>
      </Grid>

      {products.length === 0 ? (
        <Typography sx={styles.text}>
          削除すると元に戻すことはできません。よろしいですか？
        </Typography>
      ) : (
        <>
          {amountOfProduct > 5 ? (
            <Typography sx={styles.text}>
              この共有者は、以下を含む{amountOfProduct}
              件の建材を担当しています。
            </Typography>
          ) : (
            <Typography sx={styles.text}>
              この共有者は、以下の{amountOfProduct}
              件の建材を担当しています。
            </Typography>
          )}

          <Grid container flexDirection={'column'} mt={'24px'} gap={'10px'}>
            {products &&
              products.map(
                (product: MyProductGetProductType, index: number) => (
                  <Grid container flexDirection={'row'}>
                    <Typography
                      sx={{
                        color: primary100,
                        fontSize: '16px',
                        fontWeight: '700'
                      }}
                    >
                      ・
                    </Typography>
                    <Typography
                      key={index}
                      onClick={() =>
                        navigate(`/material/${product.id}`, {
                          state: {
                            productInfoId: product.product_info_id
                          }
                        })
                      }
                      sx={styles.link}
                    >
                      {product.name}
                    </Typography>
                  </Grid>
                )
              )}
          </Grid>

          <Typography sx={styles.text}>
            {
              'この共有者を削除した場合、代表者権限のユーザーが建材の担当として設定されます。\n削除すると元に戻すことはできません。よろしいですか？'
            }
          </Typography>
        </>
      )}

      <Grid container justifyContent="space-between" sx={{ mt: '40px' }}>
        <Button
          onClick={() => setDialogOpen(false)}
          sx={[tertiaryButtonOutlinedColor, styles.button]}
          variant="outlined"
        >
          キャンセル
        </Button>
        <Button
          onClick={() => onDelete()}
          sx={[primaryButtonBackgroundColor, styles.button]}
          variant="contained"
        >
          削除する
        </Button>
      </Grid>
    </Dialog>
  );
};

export default DeleteMemberModal;
